/** Shared user-facing copy — keep tone professional and consistent. */

export const MSG = {
  network:
    "Unable to reach the server. Check your internet connection and try again.",
  requestFailed: "Something went wrong. Please try again.",
  loadVessel: "Unable to load your assigned vessel.",
  loadVesselInfo: "Unable to load vessel information. Try signing in again.",
  loadMarpolHistory:
    "Unable to load record book history. Select a vessel and try again.",
  loadVoyageRoute: "Unable to load the voyage route. Try again.",
  saveVoyageRoute: "Unable to save the voyage route. Check all ports and dates, then try again.",
  marpolEntrySaved: "Entry saved.",
  marpolEntrySaveFailed:
    "Unable to save this entry. Check required fields and try again.",
  marpolSignFailed:
    "Could not apply signature. Check your PIN and signature image, then try again.",
  marpolBatchSignFailed: "Batch sign-off failed. Refresh the page and try again.",
  marpolStrikeOutFailed:
    "Could not strike out this entry. Try again or contact support.",
  loadFleetOverview: "Unable to load fleet overview. Try again.",
  loadVesselReports: "Unable to load vessel reports. Try again.",
  loadActivityLog:
    "Unable to load activity records. Check your connection and try again.",
  loadNotifications: "Unable to load notifications. Try again.",
  loadPendingApprovals: "Unable to load pending approvals.",
  loadDashboardData: "Unable to load dashboard data. Try again.",
  loadRecordBookEntries: "Unable to load record book entries. Try again.",
  approveFailed: "Unable to approve this entry.",
  loadUsers: "Unable to load users. Check your connection and try again.",
  loadVessels: "Unable to load vessels. Try again.",
  loadCrew: "Unable to load crew. Try again.",
  loadCrewHistory: "Unable to load crew history. Try again.",
  loadPageData: "Unable to load page data. Try again.",
  loadDeckLogs: "Unable to load deck logs. Try again.",
  loadDeckLog: "Unable to load deck log. Try again.",
  loadEngineLogs: "Unable to load engine logs. Try again.",
  loadEngineLogPreview: "Unable to load engine log preview. Try again.",
  loadNoonReport: "Unable to load noon report. Try again.",
  loadVoyageData: "Unable to load voyage data. Try again.",
  loadVoyageInfo: "Unable to load voyage information. Try again.",
  loadVoyage: "Unable to load voyage. Try again.",
  loadPortReport: "Unable to load port report. Try again.",
  loadInputLimits: "Unable to load input limits. Try again.",
  loadEospReport: "Unable to load EOSP report. Try again.",
  loadSospReport: "Unable to load SOSP report. Try again.",
  loadReport: "Unable to load report. Try again.",
  loadApprovals: "Unable to load approvals. Try again.",
  loadMessages: "Unable to load messages. Try again.",
  loadTicketDetails: "Unable to load ticket details. Try again.",
  loadSupportTickets: "Unable to load support tickets. Try again.",
  loadCrewGroups: "Unable to load crew groups. Try again.",
  loadVesselGroups: "Unable to load vessel groups. Try again.",
  loadKpiSetup: "Unable to load KPI setup. Try again.",
  loadKpiDataBase: "Unable to load KPI data. Try again.",
  loadQualifications: "Unable to load qualifications. Try again.",
  loadDepartments: "Unable to load departments. Try again.",
  loadExperienceTypes: "Unable to load experience types. Try again.",
  loadStatusOptions: "Unable to load status options. Try again.",
  loadDocumentCategories: "Unable to load document categories. Try again.",
  loadPreviewDocument: "Unable to load preview. Try again.",
};

/** Map raw axios / API strings to production-safe messages. */
export const formatUserFacingError = (raw, fallback = MSG.requestFailed) => {
  let value = raw;
  if (value && typeof value === "object") {
    value = value.message || value.error || value.msg || "";
    if (value && typeof value === "object") {
      value = value.message || "";
    }
  }
  const text = String(value || "").trim();
  if (!text || text === "[object Object]") return fallback;

  const lower = text.toLowerCase();
  if (
    lower === "network error" ||
    lower.includes("network error") ||
    lower.includes("err_network") ||
    lower.includes("npm run api:start") ||
    lower.includes("econnrefused") ||
    lower.includes("failed to fetch")
  ) {
    return MSG.network;
  }
  if (lower === "request failed" || lower === "server error") {
    return fallback;
  }
  if (lower === "something went wrong") {
    return fallback;
  }

  if (lower.startsWith("failed to load")) {
    return fallback;
  }

  return text;
};

export const isDevEnvironment = () =>
  process.env.NODE_ENV !== "production";

/** Show demo login hint on local dev and the demo deployment host. */
export const showDemoLoginHint = () => {
  if (isDevEnvironment()) return true;
  if (typeof window === "undefined") return false;
  const host = window.location.hostname || "";
  return host === "localhost" || host === "127.0.0.1";
};
